export default [
    {
        path: '/center',
        name: 'center',
        redirect: '/center/userinfo',
        component: () => import('@/views/center'),
        meta: { title: '我的' },
        children: [
            {
                path: 'userinfo',
                name: 'userinfo',
                component: () => import('@/views/center/userinfo'),
                meta: { title: '账号信息', loginStatus: true }
            },
            {
                path: 'myexam',
                name: 'myexam',
                component: () => import('@/views/center/myexam'),
                meta: { title: '我的考试', loginStatus: true }
            },
			{
			    path: 'mypay',
			    name: 'mypay',
			    component: () => import('@/views/center/mypay'),
			    meta: { title: '我的支付', loginStatus: true }
			},
			{
			    path: 'mycertificate',
			    name: 'mycertificate',
			    component: () => import('@/views/center/mycertificate'),
			    meta: { title: '我的电子证书', loginStatus: true }
			},
			{
			    path: 'preview/:id',
			    name: 'cpreview',
			    component: () => import('@/views/center/preview'),
			    meta: { title: '查看详情', loginStatus: true }
			},
            {
                path: 'mycertificated/:id/:type?',
                name: 'mycertificated',
                component: () => import('@/views/center/mycertificated'),
                meta: { title: '电子证书详情', loginStatus: true }
            },
			{
			    path: 'mysignup',
			    name: 'mysignup',
			    component: () => import('@/views/center/mysignup'),
			    meta: { title: '我的报名', loginStatus: true }
			},
            {
                path: 'myCertification',
                name: 'myCertification',
                component: () => import('@/views/center/myCertification'),
                meta: { title: '我的再认证', loginStatus: true }
            },
            {
                path: 'reCertification',
                name: 'reCertification',
                component: () => import('@/views/center/reCertification'),
                meta: { title: '再认证申请表', loginStatus: true }
            },
            {
                path: 'InformationValidation',
                name: 'InformationValidation',
                component: () => import('@/views/center/InformationValidation'),
                meta: { title: '再认证信息确认', loginStatus: true }
            },
            {
                path: 'dynamicMessage',
                name: 'dynamicMessage',
                component: () => import('@/views/center/dynamicMessage'),
                meta: { title: '我的通知', loginStatus: true }
            },
            {
                path: 'questionsAnswers',
                name: 'questionsAnswers',
                component: () => import('@/views/center/questionsAnswers'),
                meta: { title: '我的问答', loginStatus: true }
            },
            {
                path: 'myQuestions',
                name: 'myQuestions',
                component: () => import('@/views/center/myQuestions'),
                meta: { title: '我的提问', loginStatus: true }
            },
            {
                path: 'askQuestions',
                name: 'askQuestions',
                component: () => import('@/views/center/askQuestions'),
                meta: { title: '去提问', loginStatus: true }
            },
			{
			    path: 'myPaper',
			    name: 'myPaper',
			    component: () => import('@/views/center/myPaper'),
			    meta: { title: '我的论文', loginStatus: true }
			},
        ]
    }
]